import type { ReactNode } from 'react';

import Text from '@cartwhl/ui/base/TextNew';

import type { DashboardAppletCardData } from '../types';
import DashboardAppletCard from './DashboardAppletCard';

const APPLET_GRID_BACKGROUND_IMAGE =
  'https://resources.getcartwheel.com/share/demo-videos/bg.jpg';

export interface DashboardAppletGridProps {
  title: string;
  applets: DashboardAppletCardData[];
  emptyState?: ReactNode;
}

export default function DashboardAppletGrid({
  title,
  applets,
  emptyState,
}: DashboardAppletGridProps) {
  return (
    <section className="mx-auto flex w-full max-w-[1020px] flex-col gap-8">
      <Text
        as="h1"
        token="display/20/medium"
        leading="headline"
        className="text-primary text-pretty"
      >
        {title}
      </Text>
      {applets.length > 0 ? (
        <div
          className="bg-gray-45 grid grid-cols-1 gap-4 rounded-3xl bg-cover bg-center p-6 md:grid-cols-2 lg:grid-cols-3"
          style={{ backgroundImage: `url(${APPLET_GRID_BACKGROUND_IMAGE})` }}
        >
          {applets.map((applet) => (
            <DashboardAppletCard key={applet.id} applet={applet} />
          ))}
        </div>
      ) : (
        emptyState
      )}
    </section>
  );
}
